import React from 'react'
import ReactDOM from 'react-dom/client'
import './styles/LoadingText.css'
import App from './App.tsx'
import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import {ReactQueryDevtools} from '@tanstack/react-query-devtools'
import LoadingText from './components/LoadingText'
import {OidcProvider} from './oidc.tsx'

const queryClient = new QueryClient({
	defaultOptions: {queries: {retry: 5, retryDelay: 1000}},
})

ReactDOM.createRoot(document.getElementById('root')!).render(
	<React.StrictMode>
		<React.Suspense fallback={<LoadingText />}>
			<OidcProvider fallback={<LoadingText />}>
				<QueryClientProvider client={queryClient}>
					<App />
					{import.meta.env.VITE_ENVIRONMENT === 'local' && (
						<ReactQueryDevtools initialIsOpen={false} />
					)}
				</QueryClientProvider>
			</OidcProvider>
		</React.Suspense>
	</React.StrictMode>,
)
